import './styles/main.scss';
import React, {useEffect, useState, useCallback} from 'react';
import NavContainer from './components/nav_container';
import { District } from './components/district';
import {Footer} from './components/footer';
import {Location} from './components/location';
import { Schedule } from './components/schedule';
import {SchedulesHomepage} from './components/schedules_homepage';
import { AppHome } from './components/app_home';
import { Locations } from './components/locations';
import {CreateServiceTicket} from './components/create_service_ticket';
import { ServiceTickets } from './components/service_tickets';
import { ServiceTicket } from './components/service_ticket';
import { ClientRequests } from './components/client_requests';
import { ClientRequestDetail } from './components/client_request_detail';
import { Invoices } from './components/invoices';
import { InvoiceDetail } from './components/invoice_detail';
import { Login } from './components/login';
import { ProtectedRoute } from './components/protected_route';
import { AdminUsers } from './components/admin_users';
import { ShiftDetail } from './components/shift_detail';
import { Shifts } from './components/shifts';
import { Profile } from './components/profile';
import { Issues } from './components/issues';
import { CreateGuardRequest } from './components/create_guard_request';
import { IssueTypes } from './components/issue_types';
import { IssueDetail } from './components/issue_detail';
import { LocationDetail } from './components/location_detail';
import { Toast } from './components/toast';
import { useDispatch } from 'react-redux';
import { createBrowserRouter, createRoutesFromElements, Route, Outlet, RouterProvider, useLocation, useNavigate } from "react-router-dom";

const Root = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [toast, setToast] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    if (location.state && location.state.toast) {
      setToast(location.state.toast);
      // Clear the navigation state so toast doesn't reappear on refresh
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state]);

  const handleCloseToast = useCallback(() => setToast(null), []);

  return (
    <>
      <div>
        <NavContainer />
      </div>

      {toast && <Toast message={toast} onClose={handleCloseToast} />}

    <div>
      <Outlet />
    </div>

      <div>
        <Footer />
      </div>

  </>
)

}

const App = () => {

  const dispatch = useDispatch();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    fetch('/apisession', { credentials: 'include' })
      .then(res => res.ok ? res.json() : null)
      .then(user => {
        if (user) {
          dispatch({ type: 'LOG_IN', payload: user });
          fetch('/apivendor', { credentials: 'include' })
            .then(res => res.ok ? res.json() : null)
            .then(client => {
              if (client) dispatch({ type: 'SET_CLIENT', payload: client });
            });
        }
        setReady(true);
      })
      .catch(() => setReady(true));
  }, [dispatch]);

  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route path="/login" element={<Login />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<Root />}>
            <Route path="/" index element={<AppHome />} />
            <Route path="/district/:id" element={<District />} />
            <Route path="/location/:id" element={<Location />} />
            <Route path="/schedule/:id" element={<Schedule />} />
            <Route path="/Schedules" element={<SchedulesHomepage />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/locationDetail/:id" element={<LocationDetail />} />
            <Route path="createTicket" element={<CreateServiceTicket />} />
            <Route path="/serviceTickets" element={<ServiceTickets />} />
            <Route path="/serviceTicket/:id" element={<ServiceTicket />} />
            <Route path="/clientRequests" element={<ClientRequests />} />
            <Route path="/clientRequest/:id" element={<ClientRequestDetail />} />
            <Route path="/invoices" element={<Invoices />} />
            <Route path="/invoice/:id" element={<InvoiceDetail />} />
            <Route path="/shift/:id" element={<ShiftDetail />} />
            <Route path="/shifts" element={<Shifts />} />
            <Route path="/guardRequests/new" element={<CreateGuardRequest />} />
            <Route path="/issues" element={<Issues />} />
            <Route path="/issue/:id" element={<IssueDetail />} />
            <Route path="/issues/new" element={<IssueTypes />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/profile" element={<Profile />} />
          </Route>
        </Route>
      </>
    )
  )

  if (!ready) return null;

  return (
      <div className="App">
        <RouterProvider router={router} />
      </div>
  );
}



export default App;
